import { Component } from '@verndale/core';
import MicroModal from 'micromodal';

import { constEvent } from '../utils/constants';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $el: this.el,
      $continueBtn: this.el._$(
        '.modal-existing-pending-account-application__continue'
      )
    };
    this.modalId = null;
    this.autoShow = false;

    this.init();
  } //setupDefaults

  addListeners() {
    const { $continueBtn } = this.dom;

    $continueBtn?._on('click', this.closeModal.bind(this));
    document._on(
      constEvent.SHOW_MODAL_EXISTING_PENDING_ACCOUNT_APLICATION,
      this.showModal.bind(this)
    );
  } //addListeners

  init() {
    const { $el } = this.dom;

    const $genericModal = $el.closest('.generic-modal');
    if ($genericModal) {
      this.modalId = $genericModal.getAttribute('id') || null;
    }

    this.autoShow = $el.hasAttribute('data-generic-modal-show');

    if (this.autoShow) this.showModal();
  } //init

  showModal(e) {
    const { $continueBtn } = this.dom;
    const continueButtonUrl = e?.detail?.continueButtonUrl;
    $('.generic-modal__overlay').removeAttr('data-generic-modal-close');
    if (continueButtonUrl) {
      $continueBtn.style.display = 'block';
      $continueBtn.href = continueButtonUrl;
    } else {
      $continueBtn.style.display = 'none';
    }

    if (this.modalId) {
      MicroModal.show(this.modalId, {
        closeTrigger: 'data-generic-modal-close',
        openClass: 'generic-modal--open',
        disableScroll: true,
        disableFocus: true,
        awaitOpenAnimation: true,
        awaitCloseAnimation: true
      });
    }
  } //showModal

  closeModal() {
    if (this.modalId) {
      MicroModal.close(this.modalId);
    }
  } //closeModal
}

export default Module;
